import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface OnboardingHeaderProps {
  title: string
  progress?: number
}

const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({
  title,
  progress,
}) => (
  <>
    <h2 className={css(styles.title)}>{title}</h2>
    {progress !== undefined && (
      <div className={css(styles.progressBarContainer)}>
        <div
          className={css(styles.progressBar)}
          style={{ width: `${progress}%` }}
        />
      </div>
    )}
  </>
)

const styles = StyleSheet.create({
  title: {
    fontSize: 'clamp(22px, 3vw, 32px)',
    fontWeight: 600,
    color: '#1F3A8A',
    textAlign: 'center',
  },
  progressBarContainer: {
    width: '100%',
    height: 8,
    background: '#E5E7EB',
    borderRadius: 8,
    marginBottom: 24,
    marginTop: 8,
  },
  progressBar: {
    height: 8,
    borderRadius: 8,
    background: '#2563EB',
    transition: 'width 0.3s',
  },
})

export default OnboardingHeader
